import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const viewMenuGridSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="10" width="12" height="12" rx="2" stroke="currentColor" fill="none" strokeWidth="1.5" />
        <rect x="26" y="10" width="12" height="12" rx="2" stroke="currentColor" fill="none" strokeWidth="1.5" />
        <rect x="10" y="26" width="12" height="12" rx="2" stroke="currentColor" fill="none" strokeWidth="1.5" />
        <rect x="26" y="26" width="12" height="12" rx="2" stroke="currentColor" fill="none" strokeWidth="1.5" />
    </svg>
)

const viewMenuGridSvgSmall = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="6" height="6" rx="1" stroke="currentColor" fill="none" strokeWidth="1.25" />
        <rect x="10" y="2" width="6" height="6" rx="1" stroke="currentColor" fill="none" strokeWidth="1.25" />
        <rect x="2" y="10" width="6" height="6" rx="1" stroke="currentColor" fill="none" strokeWidth="1.25" />
        <rect x="10" y="10" width="6" height="6" rx="1" stroke="currentColor" fill="none" strokeWidth="1.25" />
    </svg>
)

const ViewMenuGridIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>{props.fontSize === 'small' ? viewMenuGridSvgSmall : viewMenuGridSvg}</SvgIcon>
)

export default ViewMenuGridIcon
